/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1378
 */

var FieldImage
var r
var i
FieldImage = require(/* 2317 */"./2317")
r = require(/* 2318 */"./2318")
i = function (e, n, i) {
  return r(FieldImage(e), n, i)
}
module.exports = {
  VERSION: "0.3.2",
  typeCheck: i,
  parsedTypeCheck: r,
  parseType: FieldImage
}
